import React, { Component } from 'react';
import moment from 'moment';

import ParkinglocationSettingsForm from './ParkinglocationSettingsForm'
import ParkinglocationModel from './ParkinglocationModel'
import UserModel from './UserModel'

import { Table, Popconfirm, Divider, Typography, Tooltip, message } from 'antd';

class ParkinglocationTable extends Component {

  state = {
    children: [],
    parkinglocationSettingsFormData: null,
  }

  columns = [{
    title: 'Kód',
    dataIndex: 'Code',
    key: 'Code',
    width: 150,
    sorter: (a, b) => a.Code - b.Code,
    render: (text, rec) => {
      return <Tooltip placement="right" title={rec.id}>{text}</Tooltip>
    },
  }, {
    title: 'Název',
    dataIndex: 'Name',
    key: 'Name',
    sorter: (a, b) => a.Name - b.Name,
  }, {
    title: 'Kapacita',
    dataIndex: 'Capacity',
    key: 'Capacity',
    width: 100,
  }, {
    title: 'Obsazeno',
    dataIndex: 'TotalOcc',
    key: 'TotalOcc',
    width: 100,
  }, {
    title: 'Čas poslední změny',
    dataIndex: 'LastChanges',
    key: 'LastChanges',
    width: 200,
    render: (text, record) => {
        if (text !== undefined) {
          return moment(text).format('L LTS');
        }
      }
  }, {
    title: 'Akce',
    key: 'Action',
    width: 200,
    render: (text, record) => {
      if (UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])) {
        return (
          <div>
            <a onClick={(e) => {
              this.props.onDetailRow
                ? this.props.onDetailRow(record)
                : null;
            }}>Detail</a>
            <Divider type="vertical" />
            <a onClick={(e) => {
              this.setState({
                parkinglocationSettingsFormData: record
              });
            }}>Nastavení</a>
            <Divider type="vertical" />
            <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
              this.props.onRemoveRow
                ? this.props.onRemoveRow(record.id)
                : null;
            }} okText="Ano" cancelText="Ne">
              <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
            </Popconfirm>
          </div>
        );
      }
    }
  }]

  render() {
    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={this.columns}
          dataSource={this.props.data}
          style={{ border: '0px' }} />
        <ParkinglocationSettingsForm
          type="modal"
          modalVisible={this.state.parkinglocationSettingsFormData === null ? false : true}
          initialValues={this.state.parkinglocationSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ parkinglocationSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            ParkinglocationModel.patch(this.state.parkinglocationSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  parkinglocationSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default ParkinglocationTable;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationTable.js